import axios from 'axios'
import store from '@/store'

// const URL = 'http://localhost/api'
const URL = 'https://www.comcasa.com.br/api/api'

class Api {
  static get (path) {
    return axios.get(`${URL}${path}`, this._getRequestOptions())
  }

  static post (path, body) {
    return axios.post(`${URL}${path}`, body, {
      headers: this._getHeaders()
    })
  }

  static postUpload (path, data) {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      formData.append(key, data[key])
    })
    return axios.post(`${URL}${path}`, formData, this._getRequestOptions())
  }

  static put (path, body) {
    return axios.put(`${URL}${path}`, body, this._getRequestOptions())
  }

  static putUpload (path, data) {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      formData.append(key, data[key])
    })
    formData.append('_method', 'PUT')
    return axios.post(`${URL}${path}`, formData, this._getRequestOptions())
  }

  static delete (path) {
    return axios.delete(`${URL}${path}`, this._getRequestOptions())
  }

  static _getRequestOptions (options = {}) {
    let requestOption = {}
    requestOption.headers = this._getHeaders(options.headers)
    return requestOption
  }

  static _getHeaders (adicionalHeaders) {
    let headers = {
      'Content-Type': 'application/json'
    }
    if (store.getters.token) {
      headers.Authorization = `Bearer ${store.getters.token}`
    }
    if (adicionalHeaders) {
      headers = {
        ...headers,
        ...adicionalHeaders
      }
    }
    return headers
  }
}

export default Api

export const API_URL = URL



// WEBPACK FOOTER //
// ./src/common/api.helper.js